import script from "./feedBackList.vue?vue&type=script&lang=ts&setup=true"
export * from "./feedBackList.vue?vue&type=script&lang=ts&setup=true"

import "./feedBackList.vue?vue&type=style&index=0&id=08342c40&lang=scss&scoped=true"

import exportComponent from "E:\\gitProject\\营城\\yingcheng\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08342c40"]])

export default __exports__